import React, {useCallback, useState, useRef} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Spinner from '@stubhub/react-spinner';

import '../styles/index.scss';

const ImageLoader = ({imgSrc, onError, onLoad, className, loading, fallbackImagePath, ...otherProps}) => {
  const [loaded, setLoaded] = useState(false);
  const [loaderror, setLoadedError] = useState(false);
  const imageRef = useRef();

  const onImageLoad = useCallback(() => {
    setLoaded(true);
    onLoad && onLoad();
  }, [onLoad]);

  const onImageError = useCallback(
    (e) => {
      if (fallbackImagePath && imageRef.current.src !== fallbackImagePath) {
        imageRef.current.src = fallbackImagePath;
      } else {
        setLoadedError(true);
      }
      onError && onError(e);
    },
    [fallbackImagePath, onError]
  );

  const showClass = cx(className, 'ImageLoader', {
    'ImageLoader--state-show': loaded,
    'ImageLoader--state-hide': loaderror,
  });

  return loading ? (
    <Spinner />
  ) : (
    <img
      ref={imageRef}
      src={imgSrc}
      onError={onImageError}
      onLoad={onImageLoad}
      className={showClass}
      {...otherProps}
    />
  );
};

ImageLoader.propTypes = {
  /** Additional CSS class names for styling */
  className: PropTypes.string,

  /** Source URL for the image (required) */
  imgSrc: PropTypes.string.isRequired,

  /** Callback triggered on image load error */
  onError: PropTypes.func,

  /** Callback triggered on image load success */
  onLoad: PropTypes.func,

  /** Path to the fallback image displayed on error */
  fallbackImagePath: PropTypes.string,

  /** Indicates if a loading state should be shown */
  loading: PropTypes.bool,
};

export default ImageLoader;
